import * as React from "react";
import { Box, Grid, Stack, styled } from "@mui/material";
import { ITransaction } from "../../../../config/transactions";
import { IAttachment } from "../../../../config/attachments";
import { PageOuterContainer } from "../../../Components/PageOuterContainer";
import { Details } from "../SharedFields/Details";
import { Location } from "../SharedFields/Location";
import { Attachments } from "../SharedFields/Attachments";
import { Extras } from "../SharedFields/Extras";
import { Amount } from "../SharedFields/Amount";
import { Title } from "../SharedFields/Title";
import { Actions } from "./Fields/Actions";

const Container = styled(Box)(({theme}) => ({
    // border: 'solid 1px red',

    width: 900,
}));

interface IDesktopViewProps {
    transaction: ITransaction;
    attachments: IAttachment[];
}

export const DesktopView = ({transaction, attachments}: IDesktopViewProps) => {
    const leftHasContent = (!!transaction.payment_method_id || !!transaction.payment_method_id || !!transaction.payment_method_id || !!transaction.description || !!transaction.location);
    const rightHasContent = (!!attachments.length || !!transaction.details);

    return (
        <PageOuterContainer sx={{display: 'flex', justifyContent: 'center'}}>
            <Container>
                <Grid container spacing={2}>
                    <Grid size={{xs: 12}} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <Box>
                            <Title transaction={transaction} />
                        </Box>
                        <Box>
                            <Actions transaction={transaction} />
                        </Box>
                    </Grid>

                    <Grid size={{xs: 12}} sx={{marginBottom: 2}}>
                        <Amount transaction={transaction} />
                    </Grid>

                    <Grid size={{xs: 12, sm: rightHasContent ? 6 : 12}}>
                        {/* <Box> is need for Stack */}
                        <Stack spacing={3}>
                            {!!transaction.location && (
                                <Box><Location transaction={transaction} /></Box>
                            )}

                            {(!!transaction.payment_method_id || !!transaction.payment_method_id || !!transaction.payment_method_id || !!transaction.description) && (
                                <Box><Details transaction={transaction} /></Box>
                            )}
                        </Stack>
                    </Grid>
                    <Grid size={{xs: 12, sm: leftHasContent ? 6 : 12}}>
                        {/* <Box> is need for Stack */}
                        <Stack spacing={3}>
                            {!!attachments.length && (
                                <Box><Attachments attachments={attachments} /></Box>
                            )}

                            <Extras transaction={transaction} attachments={attachments} />
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
        </PageOuterContainer>
    );
};
